export default "__VITE_ASSET__ca414f7f__"